import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import * as moment from 'moment';
import { toast } from 'react-toastify';
import LogoutModel from './LogoutModel';
import { fncGetPnrHistory } from '../Utility/ApiCall.js';
import { shortcutKeyForPage, shortcutKeys } from '../Utility/CommonFun.js';
import { bookingPnrHistory } from '../ReduxState';

function PnrHistory({handleSideMenu}) {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const redirectTo = useSelector(state => state.sidemenu.redirectionPage);
    let pnrHistory = useSelector(state => state.sidemenu.pnrHistory);
    const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
    const [triggerModal, settriggerModal] = useState(false);

    const goBack = () => {
        history.push(redirectTo);
    }

    const notify = (e) =>
        toast.error(e, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
        });


    if (pnrHistory) {
        pnrHistory = pnrHistory.sort((function (a, b) { return new Date(b.createdDate) - new Date(a.createdDate) }));
    }


    useEffect(() => {
        // debugger
        if (pnrHistory) {
            return;
        }
        getPnrHistory();
    }, [pnrHistory]);

    useEffect(() => {
        // console.log('SearchedFlightDetails', SearchedFlightDetails, SearchedRecordData, stSearchedRecordData);
        document.addEventListener("keydown", function (event) {
            // console.log('event', event);
            if (event.key && shortcutKeys.includes(event.key)) {
                const path = shortcutKeyForPage(location.pathname, event, SearchedFlightDetails);
                if (path) {
                    history.push('/' + path);
                }
            }
        });
    });

    useEffect(() => {
        // Define the function that checks for the Escape key
        const handleKeyDown = (event) => {
          if (event.key === "Escape") {
            goBack(); // Close the popup
          }
        };
    
        // Add the event listener when the component mounts
        document.addEventListener("keydown", handleKeyDown);
    
        // Clean up the event listener when the component unmounts
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [redirectTo]);

    useEffect(() => {
                  //  debugger
                   document.addEventListener("keydown", function (event) {  
                     if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
                       handleSideMenu();
                     }
                   })
                 });

    const getPnrHistory = () => {
        fncGetPnrHistory(SearchedFlightDetails.bookingKey)
            .then((result) => {
                if (result.status == "401" && result.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    //     notify(returnVal.statusText);
                    settriggerModal(true);
                }
                else {
                    if (!result.data.isError) {
                        console.log(result.data.pnrHistories)
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        dispatch(bookingPnrHistory(
                            {
                                type: "",
                                pnrHistory: result.data.pnrHistories
                            }
                        ));
                    }
                    else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify(result.data.errorDetail.errorMessage);
                        console.log(result.data.errorDetail);
                    }
                    document.getElementById("showAndHideSpinner").style.display = "none";
                }

            })
            .catch(err => console.log("Axios err: ", err))
    }

    const getDate = (dateString) => {
        const d = new Date(dateString).toString();
        return d.substr(0, d.indexOf(':')-2);
    }

    const getTime = (dateString) => {
        const d = new Date(dateString).toString();
        return d.substr(d.indexOf(':')-2);
    }

    return (
        <div>
            <LogoutModel trigger={triggerModal}> </LogoutModel>
            <div class="row mx-0 pnrHistories">
                <div class="col-12 mt-4 pnr-history rounded sp-tab-content box-white-shadow">
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-6  mb-3">
                            <h4 class="font-xxl mb-3 dark-text">
                                PNR History
                            </h4>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 d-flex justify-content-end  mb-3">
                            <div class="form-group comment-search sp-formField align-self-center mb-0">
                                <a aria-label="Close" onClick={goBack}
                                onKeyDown={(e)=>{
                                    if (e.key === "Enter") {
                                        goBack();
                           } } } ><i class="fa fa-times OrangeShadow" tabIndex={1}></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="history-details">
                        <div class="pnr-history-list">
                            {
                                pnrHistory && pnrHistory.length &&
                                pnrHistory.map((history, index) => (
                                    <div key={index} class={index === 0 ? 'pnr-history-list-item active' : 'pnr-history-list-item'}>
                                        <div class="pnr-date-time">
                                            <p class="date mb-0 font-sm text-dark">{ getDate(history.createdDate)}</p>
                                            <p class="time mb-0 font-sm">{getTime(history.createdDate)}</p>
                                        </div>
                                        <div class="history-details">
                                            <div class="pnr-heading">
                                                <div class="caller ms-4">
                                                    <p class="mb-0 font-xs mid-dark-text">CALLER</p>
                                                    <p class="font-sm dark-text">{history.receivedBy ? history.receivedBy : ''}</p>
                                                </div>
                                                <div class="agent">
                                                    <p class="mb-0 font-xs mid-dark-text">AGENT</p>
                                                    <p class="font-sm dark-text">{history.pointOfSale.agentCode}</p>
                                                </div>
                                            </div>
                                            <div class="history-list">
                                                <div class="history-list-item">
                                                    <p class="dark-text font-sm mb-0">{history.event}</p>
                                                    <p class="font-sm mid-dark-text">{history.details}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PnrHistory;